









import { Vue, Component, Prop, Model, Emit } from 'vue-property-decorator';

@Component
export default class MultiSelect extends Vue {
    @Model('change', { type: Array, default: () => [] })
    readonly value!: any[];

    @Prop({ type: Array, default: () => [] })
    readonly options!: any[];

    @Prop({ type: String, default: '多选' })
    readonly label!: string;

    @Prop({ type: String, default: '请选择' })
    readonly placeholder!: string;

    @Emit('change')
    handleChange(value: any[]) {
        return value;
    }

    /**
     * 获取选项的键值
     */
    getOptionKey(item: any): any {
        return typeof item === 'object' ? item.id || item.value : item;
    }

    /**
     * 获取选项的显示标签
     */
    getOptionLabel(item: any): string {
        return typeof item === 'object' ? item.name || item.label || item.displayName : item;
    }

    /**
     * 获取选项的值
     */
    getOptionValue(item: any): any {
        return typeof item === 'object' ? item.id || item.value : item;
    }
}
